<div class="content">
  <h1>Gemeinde {{ municipality }}</h1>

  <p class="text">{{ description }}</p>

  <app-poi-list municipality="{{municipality}}"></app-poi-list>
</div>
